export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Trang chủ',
          icon: 'cil-speedometer',
          to: '/dashboard.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý thiết bị',
          icon: 'cil-devices',
          to: '/devices-management/list.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý nội dung',
          icon: 'cil-file',
          items: [
            {
              name: 'Nội dung bảng điện tử đã biên tập',
              to: '/files-screen-management/managed-files.html',
            },
            {
              name: 'Biên tập nội dung bảng điện tử',
              to: '/files-screen-management/upload-screen.html',
            },
            {
              name: 'Biên tập danh sách phát',
              to: '/files-screen-management/play-list.html',
            },
            {
              name: 'Nội dung trình diễn',
              to: '/files-screen-management/slide-show.html'
            },
            {
              name: 'Cấu hình trình diễn từ nguồn',
              to: '/files-screen-management/slide-show-central.html'
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý lịch phát',
          icon: 'cil-book',
          items: [
            {
              name: 'Lịch phát',
              to: '/schedule-management/managed-shedule.html',

            },
            {
              name: 'Nhật ký lịch phát',
              to: '/history-management/managed-history.html',

            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị',
          icon: 'cil-settings',
          items: [
            {
              name: 'Nhật ký hoạt động',
              to: '/administrator/user-activity-log.html',
            },
            {
              name: 'Quản lý thao tác Rashberry Pi',
              to: '/administrator/pi-action-config.html',
            },
            {
              name: 'Quản lý tiến trình',
              to: '/administrator/thread.html',
            },
            // {
            //   name: 'Danh sách đơn vị',
            //   to: '/administrator/managed-org',
            // },
            // {
            //   name: 'Danh sách tiện ích',
            //   to: '/administrator/managed-widget.html',
            // },
            // {
            //   name: 'Danh sách cấu hình đơn vị - người dùng',
            //   to: '/administrator/managed-user-org',
            // }
          ]
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Hướng dẫn sử dụng',
          icon: 'cil-hd',
          to: '#'
        },
      ]
    },
  ]
}
